/* Copyright (c) 2017 Backpack Health LLC */

import { LocalizedText } from '../utilities/localizedUtil';
import { DateOfBirthPrecision, RGBA } from '../utilities/types';
import ShareCardIncludedTypeNames from '../constants/ShareCardIncludedTypeNames';
import { I18nImageType } from './GroupMetadata';

export enum AttributeState {
  excluded = 'excluded',
  optional = 'optional',
  defaulted = 'defaulted',
  required = 'required',
}

export enum ShareCardDefinitionBackpackCategory {
  files = 'files',
  notes = 'notes',
  contacts = 'contacts',
  groupContent = 'groupContent',
  trackables = 'trackables',
  trackablesAll = 'trackables_all',
  trackablesLatest = 'trackables_latest',
  trackablesOccurrence = 'trackables_occurrence',
}
export interface ShareCardDefinition {
  id: number;
  group_id: number;
  uid: string;
  multi_instance: boolean;
  auto_added: boolean;
  group_accessible: boolean;
  hidden: boolean;
  user_deletable: boolean;
  title_editable: boolean;
  date_of_birth_precision: DateOfBirthPrecision;
  created_at: Date;
  updated_at: Date;
  name: LocalizedText;
  title: LocalizedText;
  description: LocalizedText;
  group_content_allowed: boolean;

  comment: {
    health_entry: AttributeState;
  };

  profile: {
    name: AttributeState;
    photo: AttributeState;
    date_of_birth: AttributeState;
    gender: AttributeState;
    birth_sex: AttributeState;
    race: AttributeState;
    blood_type: AttributeState;
    residence: AttributeState;
  };

  health_entry: {
    conditions: AttributeState;
    procedures: AttributeState;
    medications: AttributeState;
    treatments: AttributeState;
    allergies_medication: AttributeState;
    allergies_food: AttributeState;
    allergies_other: AttributeState;
    vaccinations: AttributeState;
    genetic_results: AttributeState;
    genetic_results_occurrence: ShareCardIncludedTypeNames;
    labs: AttributeState;
    labs_occurrence: ShareCardIncludedTypeNames;
    measurements: AttributeState;
    measurements_occurrence: ShareCardIncludedTypeNames;
  };

  backpack: {
    files: AttributeState;
    notes: AttributeState;
    contacts: AttributeState;
    groupContent: AttributeState;
    trackables: AttributeState;
    trackables_all: AttributeState;
    trackables_latest: AttributeState;
    trackables_occurrence: AttributeState;
  };

  share_card: {
    comments: AttributeState;
    url: AttributeState;
  };

  color?: {
    type: 'group-color' | 'group-defined';
    rgba: RGBA;
  };

  icon: {
    type: 'group-logo' | 'group-defined';
    url_dark: I18nImageType;
    url_light: I18nImageType;
  };

  allow_creation: boolean;
  allow_medical_jewelry: boolean;
}
